function initializeModal () {
  $('#contactModal').on('show.bs.modal', function (event) {
    $(this).find('.modal-body').html()
    var button = $(event.relatedTarget) // Button that triggered the modal
    var plan = button.data('plan') // Extract info from data-* attributes
    var planId = button.data('planid')
    var contactInfo = $(`#container-${planId}`)
    $(this).find('.modal-title').text(plan)
    $(this).find('.modal-body').html(contactInfo)
  })
}

function renderContact (type, data) {
  try {
    return data[type].map(function (next) {
      return `<span>${next.common_name}</span>`
    }).join('<br />')
  } catch (e) {
    return null
  }
}

function renderContactData (data, options) {
  var defaultOptions = {
    gsasOnly: false
  }

  var _settings = $.extend({}, defaultOptions, options)

  var planName = data.plan.replace('(PHD)', '(PhD)')
  var admissions = normalizeContact(data.contacts.GADM)
  var coordinators = normalizeContact(data.contacts.GCOR)
  var dgs = normalizeContact(data.contacts.DGS)
  var gsas = normalizeContact(data.contacts.GCAUD)
  var website = Object.values(data.owned_by).map(function (next) {
    return `<div class="mb-4 contacts dept">
      <a href="${next.org_website}">${next.org_name}</a><br />
      <span class="font-weight-light">${next.college_name}</span>
    </div>`
  }).join('<br />')
  var catalog = `<a href="https://grad.arizona.edu/catalog/programinfo/${data.uacadplan}">
      ${planName}
    </a>`

  var contactDetails = _settings.gsasOnly
    ? `<dt class="font-weight-normal"><abbr title="Graduate College Degree Auditor">Degree Auditor</abbr></dt>
       <dd>${gsas}</dd>
       <dt class="font-weight-normal">Catalog Description</dt>
       <dd>${catalog}</dd>`
    : `<dt class="font-weight-normal"><abbr title="Department/Program Admissions Contact">Admissions</abbr></dt>
       <dd>${admissions}</dd>
       <dt class="font-weight-normal"><abbr title="Graduate Program Coordinator">Coordinator</abbr></dt>
       <dd>${coordinators}</dd>
       <dt class="font-weight-normal"><abbr title="Director of Graduate Studies">DGS</abbr></dt>
       <dd>${dgs}</dd>
       <dt class="font-weight-normal"><abbr title="Graduate College Degree Auditor">Degree Auditor</abbr></dt>
       <dd>${gsas}</dd>
       <dt class="font-weight-normal">Dept Website</dt>
       <dd>${website}</dd>
       <dt class="font-weight-normal">Catalog Description</dt>
       <dd>${catalog}</dd>`

  return `<div>
    <a data-target="#contactModal"
      data-toggle="modal"
      data-plan="${planName}"
      data-planid="${data.uacadplan}"
      href="#"
      id="${data.uacadplan}"
    >
      ${planName}
    </a>
    <div hidden>
      <dl id="container-${data.uacadplan}">
        ${contactDetails}
      </dl>
    </div>
  </div>`
}

function renderStaffData (data, options) {
  var defaultOptions = {}
  var _settings = $.extend({}, defaultOptions, options)
  var normalizedContact = normalizeContact(data)
  var contactDetails =
    `<dt class="font-weight-normal"><abbr title="Name">Name</abbr></dt>
     <dd>${normalizedContact.common_name}</dd>
     <dt class="font-weight-normal"><abbr title="Title">Title(s)</abbr></dt>
     <dd>${normalizedContact.titles}</dd>
     <dt class="font-weight-normal"><abbr title="Email">Email</abbr></dt>
     <dd>${normalizedContact.email}</dd>
     <dt class="font-weight-normal"><abbr title="Phone">Phone</abbr></dt>
     <dd>${normalizedContact.phone}</dd>`

  return `<div>
    <a data-target="#contactModal"
      data-toggle="modal"
      href="#"
      id="${normalizedContact.netid}"
    >
      ${normalizedContact.common_name}
    </a>
    <div hidden>
      <dl id="container-${normalizedContact.netid}">
        ${contactDetails}
      </dl>
    </div>
  </div>`
}

function normalizePhone (phoneNbr) {
  if (phoneNbr === null) {
    return phoneNbr
  }

  // normalize string and remove all unnecessary characters
  phoneNbr.replace(/[^\d]/g, '')

  // check if number length equals to 10
  if (phoneNbr.length === 10) {
    // reformat and return phone number
    return phoneNbr.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }

  return phoneNbr
}

function normalizeTitles (titles) {
  if (typeof (titles) === 'object') {
    var stringValues = Object.values(titles)
    return stringValues.join('<br />')
  }

  return titles.join('<br />')
}

function normalizeUnits(units) {
  if (typeof (units) === 'object') {
    var stringValues = Object.values(units)
    return stringValues.join('<br />')
  }

  return units.join('<br />')
}

function normalizeContact (contact) {
  return contact !== null
    ? contact.map(function (next) {
      var normalPhone = normalizePhone(next.phone)
      return `<div class="mb-4 contact">
        <a href="mailto:${next.email}">${next.common_name}</a><br />
        <a href="tel:+1${next.phone}">${normalPhone}</a>
      </div>`
    }).join('<br />')
    : '<span>n/a</span>'
}
